// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import color from "@gcg/XDL/Utilities/color";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const wrapperCss = css`
    border-top: 3px solid ${getColor("primary.main")};
    box-shadow: 0 1px 2px 0 ${color("secondary.main", 0.1)};
    height: 100%;
    width: 100%;
    transition: box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 1px 2px 0 ${color("secondary.main", 0.3)};
    }

    & > span {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        width: 100%;
    }

    .bg-image {
        background-size: cover;
        background-position: center;
        height: 150px;
        margin-bottom: 12px;
        flex: 0 0 150px;
    }
`;

const textContentWrapperCss = css`
    display: flex;
    flex-direction: column;
    padding: 0 10px 10px 10px;
    flex: 1 1 auto;
`;

const textContentDescriptionCss = css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

const headingCss = css`
    letter-spacing: 0.3px;
    text-transform: Uppercase;
    margin-bottom: 15px;
`;

const iconWrapperCss = css`
    text-align: right;
    line-height: 1;
`;

const copyCss = css`
    margin-bottom: 10px;
`;

const linkHoverStyles = { textDecoration: "none" };

const InfoCardStyles = {
    wrapperCss,
    textContentWrapperCss,
    headingCss,
    iconWrapperCss,
    copyCss,
    textContentDescriptionCss,
    linkHoverStyles,
};

export default InfoCardStyles;
